import React from 'react';
import styled, { keyframes } from 'styled-components';
import colors from 'theme/colors';
import eventTypes from 'theme/eventTypes';
import indexPriority from 'theme/z-index';
import { getCategoryIcon } from 'modules/events/categories/categoryIconMap';

const PIN_SIZE = 46;
const TAIL_HEIGHT = 9;

function getAccentColor(type) {
  if (type === eventTypes.free.slug)  return eventTypes.free.color;
  if (type === eventTypes.paid.slug)  return eventTypes.paid.color;
  return colors.occasionalPurple;
}

function EventMarker({ iconKey, image, type, name, onMarkerClick }) {
  const accent = getAccentColor(type);
  const IconComp = iconKey ? getCategoryIcon(iconKey) : null;

  return (
    <PinWrapper id={`map_marker_${name}`} onClick={() => onMarkerClick()}>
      <PinHead $accent={accent}>
        {IconComp ? (
          <IconComp size={22} color={accent} strokeWidth={2} />
        ) : (
          <Avatar
            src={image || '/assets/images/placeholder-events.png'}
            alt={name}
            onError={(e) => { e.target.onerror = null; e.target.src = '/assets/images/placeholder-events.png'; }}
          />
        )}
        <TailPointer $accent={accent} />
      </PinHead>
    </PinWrapper>
  );
}

const dropIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-12px) scale(0.7);
  }
  60% {
    transform: translateY(2px) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const PinWrapper = styled.div`
  position: absolute;
  left: ${-PIN_SIZE / 2}px;
  top: ${-(PIN_SIZE + TAIL_HEIGHT)}px;
  cursor: pointer;
  z-index: ${indexPriority.normal};
  filter: drop-shadow(0 2px 8px rgba(26, 26, 26, 0.2));
  animation: ${dropIn} 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  transition: transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1),
              filter 0.18s ease;

  &:hover {
    transform: scale(1.14) translateY(-2px);
    filter: drop-shadow(0 6px 14px rgba(26, 26, 26, 0.28));
    z-index: ${indexPriority.medium};
  }

  &:active {
    transform: scale(1.04);
  }
`;

const PinHead = styled.div`
  position: relative;
  width: ${PIN_SIZE}px;
  height: ${PIN_SIZE}px;
  border-radius: 50%;
  background: ${colors.neutralLight};
  border: 2.5px solid ${({ $accent }) => $accent};
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TailPointer = styled.div`
  position: absolute;
  bottom: -${TAIL_HEIGHT}px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: ${TAIL_HEIGHT}px solid ${({ $accent }) => $accent};
`;

const Avatar = styled.img`
  width: ${PIN_SIZE - 6}px;
  height: ${PIN_SIZE - 6}px;
  border-radius: 50%;
  object-fit: cover;
`;

export default EventMarker;
